exports.FOLD = "FOLD";
exports.CHECK = "CHECK";
exports.CALL = "CALL";
exports.RAISE = "RAISE";
exports.ALL_IN = "ALL_IN";
exports.WINNER = "WINNER";

exports.FETCH_LOBBY_INFO = "FETCH_LOBBY_INFO";
exports.RECEIVE_LOBBY_INFO = "RECEIVE_LOBBY_INFO";
exports.PLAYERS_UPDATED = "PLAYERS_UPDATED";

exports.JOIN_TABLE = "JOIN_TABLE";
exports.TABLE_JOINED = "TABLE_JOINED";
exports.LEAVE_TABLE = "LEAVE_TABLE";
exports.TABLE_LEFT = "TABLE_LEFT";
exports.TABLES_UPDATED = "TABLES_UPDATED";
exports.GET_TABLE = "GET_TABLE";
exports.TABLE_UPDATED = "TABLE_UPDATED";
exports.TABLE_MESSAGE = "TABLE_MESSAGE";
exports.REBUY = "REBUY";
exports.SEATS_REBUY = "SEATS_REBUY";

exports.SIT_DOWN = "SIT_DOWN";
exports.STAND_UP = "STAND_UP";
exports.SITTING_OUT = "SITTING_OUT";
exports.SITTING_IN = "SITTING_IN";
exports.SITTING_ACTION = "SITTING_ACTION";

exports.DISCONNECT = "DISCONNECT";

exports.BETTING_ACTION = "BETTING_ACTION";
exports.ACTION_SITTED = "ACTION_SITTED";
exports.ACTION_FOLDED = "ACTION_FOLDED";
exports.ACTION_CALLED = "ACTION_CALLED";
exports.ACTION_RAISED = "ACTION_RAISED";
exports.ACTION_CHECKED = "ACTION_CHECKED";

exports.ROUND_CHANGED = "ROUND_CHANGED";
exports.END_HAND = "END_HAND";
exports.ACK_END_HAND="ACK_END_HAND";
exports.PREPLAY_ACTION = "PREPLAY_ACTION";
exports.NO_PREPLAYACTION = "NO_PREPLAYACTION";
exports.GPS_CHANGE = "GPS_CHANGE";
exports.PLAYER_CHIP_TOP_UP = "PLAYER_CHIP_TOP_UP";
exports.JOIN_WAITLIST = "JOIN_WAITLIST";
exports.JOINED_WAITLIST = "JOINED_WAITLIST";
exports.LEAVE_WAITLIST = "LEAVE_WAITLIST";
exports.WAITLIST_SEATAVAILABLE = "WAITLIST_SEATAVAILABLE";
exports.PLAYER_CHIP_WITHDRAWAL = "PLAYER_CHIP_WITHDRAWAL";
exports.PLAYER_EXIT_TABLE = "PLAYER_EXIT_TABLE";
exports.SEAT_EXIT_TABLE = "SEAT_EXIT_TABLE";
exports.SEATS_UPDATE = "SEATS_UPDATE";
exports.EXIT_NOTALLOWED = "EXIT_NOTALLOWED";
exports.BB_POST = "BB_POST";
exports.ALL_HAND_HISTORY = "ALL_HAND_HISTORY";
exports.UPDATE_SINGLE_SEAT = "UPDATE_SINGLE_SEAT";
exports.TOGGLE_STRADDLE = "TOGGLE_STRADDLE";
exports.STRADDLE_POST = "STRADDLE_POST";
exports.STRADDLE_UPDATE = "STRADDLE_UPDATE";
exports.STRADDLE_CANCEL= "STRADDLE_CANCEL";
exports.REAL_TIME_RESULTS = "REAL_TIME_RESULTS";
exports.BOMB_POT = "BOMB_POT";
exports.EV_CALC = "EV_CALC";
exports.EV_CALC_RES = "EV_CALC_RES";
exports.SQUID_ROUND_START = "SQUID_ROUND_START";
exports.SQUID_ROUND_INFO = "SQUID_ROUND_INFO";
exports.SQUID_ROUND_END = "SQUID_ROUND_END";
exports.SQUID_ROUND_RES = "SQUID_ROUND_RES";
exports.TABLE_BUY_IN = "TABLE_BUY_IN";
exports.TABLE_BUY_IN_RES = "TABLE_BUY_IN_RES";
exports.CANCEL_REBUY = "CANCEL_REBUY";
exports.OFC_CONFIRM_CARDS = "OFC_CONFIRM_CARDS";
exports.OFC_RECEIVED_CARDS = "OFC_RECEIVED_CARDS";
exports.OFC_REORDERED_CARDS = "OFC_REORDERED_CARDS";
exports.OFC_END_HAND = "OFC_END_HAND";
exports.OFC_READY_TIMER_START = 'OFC_READY_TIMER_START';
exports.OFC_GET_READY = 'OFC_GET_READY';
exports.OFC_SEATS_UPDATE = 'OFC_SEATS_UPDATE';

exports.BUY_IN_CANCEL = "BUY_IN_CANCEL";
exports.BUY_IN_CONFIRM = "BUY_IN_CONFIRM";
exports.TABLE_INFO = "TABLE_INFO";
exports.OPEN_INSURANCE_MODAL = "OPEN_INSURANCE_MODAL";
exports.CLOSE_INSURANCE_MODAL = "CLOSE_INSURANCE_MODAL";
exports.SEAT_INSURANCE_PURCHASE = "SEAT_INSURANCE_PURCHASE";
exports.SEAT_INSURANCE_QUIT = "SEAT_INSURANCE_QUIT";
exports.SEAT_INSURANCE_MSG = "SEAT_INSURANCE_MSG";
exports.PREFLOP = "PREFLOP";
exports.FLOP = "FLOP";
exports.TURN = "TURN";
exports.RIVER = "RIVER";
exports.SHOWDOWN = "SHOWDOWN";
exports.LUCKYSIX_REORDERED_CARDS = "LUCKYSIX_REORDERED_CARDS";
exports.LUCKYSIX_CONFIRM_CARDS = "LUCKYSIX_CONFIRM_CARDS";

exports.FIRST_ROUND_CLEAR = "FIRST_ROUND_CLEAR";
exports.SECOND_ROUND_CARDS = "SECOND_ROUND_CARDS";

exports.PUSOY_REORDERED_CARDS = "PUSOY_REORDERED_CARDS";
exports.PUSOY_CONFIRM_CARDS = "PUSOY_CONFIRM_CARDS";

exports.MAUBINH_REORDERED_CARDS = "MAUBINH_REORDERED_CARDS";
exports.MAUBINH_CONFIRM_CARDS = "MAUBINH_CONFIRM_CARDS";

exports.THPOKER_REORDERED_CARDS = "THPOKER_REORDERED_CARDS";
exports.THPOKER_CONFIRM_CARDS = "THPOKER_CONFIRM_CARDS";

exports.TR_BUY_IN = "TR_BUY_IN";
exports.TR_BUY_IN_RES = "TR_BUY_IN_RES";
exports.TR_UPDATED_DATA = "TR_UPDATED_DATA";
exports.TR_REGISTRATION = "TR_REGISTRATION";
exports.TR_REGISTRATION_RES = "TR_REGISTRATION_RES";
exports.TR_ENTER = "TR_ENTER";
exports.TR_UN_REGISTER = "TR_UN_REGISTER";

exports.RIT_ASK_WINNER = "RIT_ASK_WINNER";
exports.RIT_ASK_PLAYERS = "RIT_ASK_PLAYERS";
exports.RIT_TAKE_ACTION = "RIT_TAKE_ACTION";
exports.RIT_STATUS = "RIT_STATUS";

exports.RISK_CONTROL="RISK_CONTROL";
exports.RISK_CONTROL_ACTION="RISK_CONTROL_ACTION";
exports.RISK_STATUS='RISK_STATUS';

exports.INSURANCE_ASK_WINNER = "INSURANCE_ASK_WINNER";
exports.INSURANCE_TAKE_ACTION = "INSURANCE_TAKE_ACTION";
exports.INSURANCE_STATUS = "INSURANCE_STATUS";
exports.INSURANCE_PURCHASED = "INSURANCE_PURCHASED";
exports.INSURANCE_CLAIM = "INSURANCE_CLAIM";

exports.DO_RABBIT = "DO_RABBIT";
exports.GET_RABBIT_CARDS = "GET_RABBIT_CARDS";

exports.BB_POSTED = "BB_POSTED";

exports.TOGGLE_SHOWINBB = "TOGGLE_SHOWINBB";
exports.TOGGLE_SQUEEZE = "TOGGLE_SQUEEZE";
exports.CARD_REVEAL = "CARD_REVEAL";
exports.DEPOSIT_RELEASE = 'DEPOSIT_RELEASE'
exports.SUSHI_START = "SUSHI_START";

exports.SUSHI_START = "SUSHI_START";
exports.SUSHI_START = "SUSHI_START";
exports.SUSHI_START = "SUSHI_START";

//chats

exports.JOIN_GAME_CHAT = 'JOIN_GAME_CHAT';
exports.CHAT_HISTORY = 'CHAT_HISTORY';
exports.RECEIVE_MESSAGES = 'RECEIVE_MESSAGES';
exports.RECEIVE_STICKERS = 'RECEIVE_STICKERS';
exports.SEND_MESSAGES= 'SEND_MESSAGES';
exports.SEND_STICKERS='SEND_STICKERS';
exports.ALL_MESSAGES = 'ALL_MESSAGES';
exports.RECEIVE_ALL_MESAGES = 'RECEIVE_ALL_MESSAGES';
exports.SEND_MESSAGES_IN_CHATROOM = 'SEND_MESSAGES_IN_CHATROOM';
exports.RECEIVE_MESSAGES_IN_CHATROOM = 'RECEIVE_MESSAGES_IN_CHATROOM';
exports.JOIN_ROOM = 'JOIN_ROOM';
exports.USER_JOINED_ROOM ="USER_JOINED_ROOM"

//for club chat
exports.JOIN_CLUB_ROOM = 'JOIN_CLUB_ROOM';
exports.CLUB_ROOM_JOINED = 'CLUB_ROOM_JOINED';
exports.LEAVE_CLUB_ROOM = 'LEAVE_CLUB_ROOM';
exports.SEND_CLUB_MESSAGE = 'SEND_CLUB_MESSAGE';
exports.DELETE_CLUB_MESSAGE = 'DELETE_CLUB_MESSAGE';
exports.CLUB_MESSAGE_DELETED = 'CLUB_MESSAGE_DELETED';
exports.RECEIVE_CLUB_MESSAGE = 'RECEIVE_CLUB_MESSAGE';
exports.ERROR_OCCURED_IN_CLUB_MESSAGE = 'ERROR_OCCURED_IN_CLUB_MESSAGE';
exports.EDIT_CLUB_MESSAGE = 'EDIT_CLUB_MESSAGE';
exports.CLUB_MESSAGE_EDITED = 'CLUB_MESSAGE_EDITED';


//Tournaments 
exports.TOURNAMENT_ABOUT_TO_START = 'TOURNAMENT_ABOUT_TO_START';
exports.TOURNAMENT_CANCELLED = 'TOURNAMENT_CANCELLED';
exports.JOIN_TOURNAMENT = 'JOIN_TOURNAMENT';
exports.JOINED_TOURNAMENT = 'JOINED_TOURNAMENT';
exports.GET_TOURNAMENT = 'GET_TOURNAMENT';
exports.TOURNAMENT_DETAILS = 'TOURNAMENT_DETAILS';
exports.TOURNAMENT_CANCELLED = 'TOURNAMENT_CANCELLED';
exports.TOURNAMENT_END = 'TOURNAMENT_END';
exports.ADDON_WILL_START = "ADDON_WILL_START";
exports.ADDON_STARTED = "ADDON_STARTED";
exports.ADDON_END = 'ADDON_END';

exports.FTDEAL_ACTION = 'FTDEAL_ACTION';
exports.FTDEAL_UPDATE = 'FTDEAL_UPDATE';
exports.FTDEAL_ASK='FTDEAL_ASK';

exports.MTT_PLAYERS_REMOVED = 'MTT_PLAYERS_REMOVED';

exports.SWITCH_TABLE='SWITCH_TABLE';
exports.DO_SWITCH_TABLE='DO_SWITCH_TABLE';
//BREAK
exports.BREAK_START='BREAK_START';
exports.BREAK_END='BREAK_END';
exports.CLEAR_TABLE='CLEAR_TABLE';



exports.ITM_STARTED = 'ITM_STARTED';
exports.BUBBLE_STARTED = 'BUBBLE_STARTED';
exports.CHECK_KO_EARN = 'CHECK_KO_EARN';








